import React, { Component } from "react";
import HelpOutlineIcon from "@material-ui/icons/HelpOutline";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import "../MembershipPage.css";

class MembershipFAQ extends Component {
    state = {
        openItems: [0]
    };

    toggleItem = (index) => {
        this.setState(prevState => {
            const openItems = [...prevState.openItems];
            const itemIndex = openItems.indexOf(index);
            if (itemIndex > -1) {
                openItems.splice(itemIndex, 1);
            } else {
                openItems.push(index);
            }
            return { openItems };
        });
    };

    render() {
        const defaultFaqItems = [
            {
                question: "Can I change my plan at any time?",
                answer: "Yes, you can upgrade or downgrade your plan at any time. Changes will take effect immediately, and we'll prorate any billing adjustments."
            },
            {
                question: "What happens to my data if I downgrade?",
                answer: "Your data is always safe. If you downgrade, you'll retain access to all your historical data, but some premium features may become unavailable."
            },
            {
                question: "How does Pay As You Go billing work?",
                answer: "With Pay As You Go, you're only charged for completed bookings. The charge is applied to your saved payment method at the end of the month."
            },
            {
                question: "What's the difference between Pay As You Go and Monthly?",
                answer: "Pay As You Go charges you per completed booking made, which is ideal if you have variable booking volumes. Monthly gives you unlimited bookings for a fixed monthly fee, which is better value if you book regularly."
            }
        ];

        const faqItems = this.props.faqItems || defaultFaqItems;

        return (
            <div className="membership-faq-section">
                <h3 className="membership-faq-title">
                    <HelpOutlineIcon style={{ color: '#fe0d9d', fontSize: 20 }} />
                    Frequently Asked Questions
                </h3>
                
                {faqItems.map((item, index) => {
                    const isOpen = this.state.openItems.includes(index);
                    return (
                        <div key={index} className="membership-faq-item">
                            <button 
                                className={`membership-faq-question ${isOpen ? 'open' : ''}`}
                                onClick={() => this.toggleItem(index)}
                            >
                                <span>{item.question}</span>
                                <KeyboardArrowDownIcon style={{ fontSize: 18 }} />
                            </button>
                            {isOpen && (
                                <div className="membership-faq-answer">
                                    {item.answer}
                                </div>
                            )}
                        </div>
                    );
                })}
            </div>
        );
    }
}

export default MembershipFAQ;
